/**
 * Same Noto fallback stack as ``apps/rve-render-service/src/fontFallbacks.ts``.
 * Keep families in sync so editor preview matches cloud MP4 (#225).
 */
export const I18N_FONT_FALLBACKS = [
  'Noto Sans SC',
  'Noto Sans JP',
  'Noto Sans KR',
  'Noto Sans Devanagari',
  'Noto Sans Arabic',
  'Noto Sans Thai',
  'Noto Sans Hebrew',
  'Noto Sans Symbols 2',
  'Noto Color Emoji',
] as const;

const I18N_FONT_FALLBACK_CSS = I18N_FONT_FALLBACKS.map((f) => `"${f}"`).join(', ');

/** Google Fonts CSS2 stylesheet for Neo preview (browser; worker uses Debian Noto). */
export function i18nGoogleFontsStylesheetHref(): string {
  const families = I18N_FONT_FALLBACKS.map((name) => {
    const encoded = encodeURIComponent(name).replace(/%20/g, '+');
    if (name === 'Noto Color Emoji' || name === 'Noto Sans Symbols 2') {
      return `family=${encoded}`;
    }
    return `family=${encoded}:wght@400;700`;
  });
  return `https://fonts.googleapis.com/css2?${families.join('&')}&display=swap`;
}

/** Append i18n/symbol fallbacks without duplicating an existing stack. */
export function applyI18nFontFallbackFamily(
  fontFamily: string | undefined,
): string {
  const primary = (fontFamily || 'Inter').trim() || 'Inter';
  if (I18N_FONT_FALLBACKS.every((f) => primary.includes(f))) {
    return primary;
  }
  return `${primary}, ${I18N_FONT_FALLBACK_CSS}, sans-serif`;
}
